import { mapStores } from "pinia"
import { useCheckboxListStore } from "./checkboxList"
import { useCitizensTrackingStore } from "./citizensTracking"
import { useSmartlistStore } from "./smartlist"

export default {
  computed: {
    /**
     * Map only those stores that might be utilized outside of components (on root level).
     * If a store is exclusively used within specific components,
     * it should be imported and defined directly within those components.
     */
    ...mapStores(
      useCheckboxListStore,
      useCitizensTrackingStore,
      useSmartlistStore
    ),
  }
}
